import React from "react";
import logo from "../assets/tekpossible-logo.svg";
import { Link } from "react-router-dom";
import insta from "../assets/fi_18522004.svg";
import twitter from "../assets/fi_3536569.svg";
import AOS from 'aos';
import 'aos/dist/aos.css';


const Footer = () => {
  const currentYear = new Date().getFullYear();
    AOS.init({
        // Global settings:
        disable: false, 
        startEvent: 'DOMContentLoaded',
        initClassName: 'aos-init',
        animatedClassName: 'aos-animate',
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        throttleDelay: 99,
      
      
        offset: 100,
        delay: 60, 
        duration: 1300, 
        easing: 'ease-in-out', 
        once: false, 
        mirror: false, 
        anchorPlacement: 'top-bottom',
      });





  return (
    <>
      <div className="bg-gradient-to-b from-[#124B6A] to-[#981A59] text-white py-10 px-6 md:px-10 lg:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center gap-5">
          <img  className="w-[207px] h-[62px]" src={logo} alt="Logo" />
          <Link
            to="/contact-us"
            className="bg-white text-[#C32A7C] px-6 py-2 rounded-lg font-semibold mt-4 md:mt-0 hover:bg-[#C32A7C] hover:text-white transition-colors duration-300"
          >
            Contact Us
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-12 gap-8 mt-10 ">

          <div className="col-span-4">
            <h2 className="font-semibold">hr@tekpossible.net</h2>
            <p className="text-sm w-3/4 mt-5">
              ©{currentYear} Tekpossible. All rights reserved. Unauthorized duplication or distribution of any content from this site is strictly prohibited.
            </p>
          </div>

          <div className="col-span-3">
            <h2 className="font-semibold">United States (Texas)</h2>
            <p className="text-sm mt-5">
              4425 W Airport Fwy, Suite
            </p>
            <p className="text-sm">#458, Irving, TX 75062</p>
            <a href="Tel: +1 (832) 568-4006" className="text-sm flex">Tel: +1 (832) 568-4006 </a>
            <a href="Fax: +1 (832) 306-3871" className="text-sm">Fax: +1 (832) 306-3871</a>
          </div>

          <div className="col-span-3">
            <h2 className="font-semibold">Canada</h2>
            <p className="text-sm mt-5">
              508 Labrador Cres,
            </p>
            <p className="text-sm">Ottawa, ON, K1T0R4</p>
            <a href="Tel: +1 (249) 995-0888" className="text-sm">Tel: +1 (249) 995-0888</a>
          </div>

          <div className="col-span-2">
            <h2 className="font-semibold">India</h2>
            <p className="text-sm mt-5">
              First Floor, IT Towers,
            </p>
            <p className="text-sm">Nizamabad, Telangana 503001</p>
            <a href="Tel: +91 (789) 389-4825" className="text-sm">Tel: +91 (789) 389-4825</a>
          </div>
        </div>

        <div className="flex justify-center md:justify-start mt-8 gap-6">
          <a href="https://www.linkedin.com/company/tekpossible/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity duration-300">
            <img src={twitter} className="w-8 h-8" alt="Linkedin" />
          </a>
          <a href="https://www.instagram.com/tekpossible/" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity duration-300">
            <img src={insta} className="w-8 h-8" alt="Instagram" />
          </a>
        </div>
      </div>
     
    </>
  );
};

export default Footer;
